var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashGreyDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,5 L14,4 L10,4 L10,5 L6,5 L6,7 L7,7 L7,17 C6.9675564,17.5397267 7.16782947,18.0675039 7.55016279,18.4498372 C7.93249612,18.8321705 8.46027326,19.0324436 9,19 L15,19 C15.5397267,19.0324436 16.0675039,18.8321705 16.4498372,18.4498372 C16.8321705,18.0675039 17.0324436,17.5397267 17,17 L17,7 L18,7 L18,5 L14,5 Z M11,17 L9,17 L9,7 L11,7 L11,17 Z M15,17 L13,17 L13,7 L15,7 L15,17 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resources-/-01_Home_page",
    transform: "translate(-1329.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components-/-header",
    transform: "translate(337.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(992.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "assets-/-colors-/-default-/-Black",
    mask: "url(#mask-2)",
    fill: "#6d6d6d"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashGreyDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trashGreyDark.88dce88bea3cff6f7717d7be80f70113.svg";